// IL LIMITE PER FILE, SCRITTO COME LO LEGGE UNA PERSONA (2026-09-14).
// "1,5 GB", "5 GB", "50 MB": decimali solo quando servono, virgola in
// italiano. Il numero arriva dal server (/api/geo/pricing -> limiti), che lo
// prende dalla stessa tabella che decide i rifiuti: qui si formatta e basta.
import { unitaByte } from './unita';

export function limiteLeggibile(byte, lingua) {
  if (!byte || byte <= 0) return null;
  const virgola = lingua === 'en' ? '.' : ',';
  const gb = byte / (1024 * 1024 * 1024);
  if (gb >= 1) return (gb === Math.floor(gb) ? String(gb) : gb.toFixed(1)).replace('.', virgola) + ' ' + unitaByte(lingua, 'GB');
  return Math.round(byte / (1024 * 1024)) + ' ' + unitaByte(lingua, 'MB');
}
